<ng-container *transloco="let t">
    <td-error [title]="t('error.not-found-title')" [message]="t('error.not-found-description')"></td-error>
    <div class="mt-4 d-flex flex-column align-items-center">
        <a mat-stroked-button color="primary" [routerLink]="['/launch']">
            <fa-icon icon="layer-group"></fa-icon>
            {{ t('general.go-to-dashboard') }}
        </a>
    </div>
</ng-container>
